import React from "react";
import HTMLReactParser from 'html-react-parser';
import { useStaticQuery, graphql } from "gatsby";
import { Link } from "@StarberryUtils";
import { GetURL } from "../common/site/functions";
import { useLocation } from "@reach/router";
import ModalTiny from "react-bootstrap/Modal"
import { PhoneIconBlue, PhoneIconGrey, EnvelopeIconBlue, EnvelopeIconGrey, WhatsAppIconBlue, WhatsAppIconGreen, CloseIcon } from "../Icons/Icons";
import Dacha from "../../images/dacha.png";
import ContactForm from "../forms/contact-form";
import "./StaticPageSidebar.scss";

const StaticPageSidebar = (props) => {
	const location = useLocation(); 
	const currentPage = typeof window !== 'undefined' ? window.location.pathname : '';
	const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule {
          Static_Page_Sidebar_Title
	      Static_Page_Sidebar_CTA_Label
	      Static_Page_Sidebar_Content
	      Static_Page_Sidebar_CTA_Link {
	        id
	      }
		  Opening_Hours
	    }
      }
    }
  `);

	const content = data.glstrapi.globalModule;

	const getPhoneNumber = () => {
		if (currentPage === '/holiday-homes/') {
			return "971 50 531 3003";
		}
		return props?.peoples[0]?.phone || props?.site?.Phone?.replace(/ /g, '').replace(/\+/g, '') || '+971 44 23 2006';
	};

	const number = getPhoneNumber();
	const location_link = `${process.env.GATSBY_SITE_URL}${location.pathname}`;
	const whatsapp_link = location.search.indexOf("utm_source") > 0 
		? `https://wa.me/971586234140?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
		: `https://wa.me/971586234140?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`;
    const wrapClass = props?.sidebarWidget?.UseDefault ? 'static-page-default-sidebar-widget' : '';

	const [modalContactformOpen, setContactformOpen] = React.useState(false);

	const openContactformModal = () => {
		setContactformOpen(true);
	}
	const closeContactformModal = () => {
		setContactformOpen(false);
	}

	return (
		<div className={`static-page-sidebar-widget ${props.class} ${wrapClass}`}>
			<div className="sidebar-top">
				<h5 className="text-lg-bold-32-18">
					{props?.sidebarWidget?.SidebarTitle || content?.Static_Page_Sidebar_Title || 'Need help?'}
				</h5>
				<div className="text-sm sidebar-intro-content">
					{HTMLReactParser(
						(props?.sidebarWidget?.SidebarContent || content?.Static_Page_Sidebar_Content || '')
							.replace(/<br\s*\/?>/gi, '')
					)}
				</div>
			</div>
            
            {props?.sidebarWidget?.UseDefault ? (	
				<div className="sidebar-contact-info sidebar-default-contact-info">
					{currentPage === '/holiday-homes/' ? (
						<Link to={`/contact`} className="btn btn-primary">{'CONTACT US'}</Link>
					) : props.popular_search === 'Popular_Search_Rent' && content.Static_Page_Sidebar_CTA_Label ? (
						<Link to={`/properties/for-rent/in-dubai`} className="btn btn-primary">{content.Static_Page_Sidebar_CTA_Label}</Link>
					) : content.Static_Page_Sidebar_CTA_Label ? (
						<Link to={`/properties/for-sale/in-dubai`} className="btn btn-primary">{content.Static_Page_Sidebar_CTA_Label}</Link>
					) : null}

					<Link href={whatsapp_link} className="btn btn-whatsapp" target="_blank">
						<span>WhatsApp</span>
					</Link>
				</div>
            ) : (
				<div className="sidebar-contact-info">
					<Link href={`tel:${number}`} className="text-xxs btn btn-light-blue">
						<span><PhoneIconBlue className="icon-contact-info" /></span><span>Call</span>
					</Link>
					<Link onClick={openContactformModal} className="text-xxs btn btn-light-blue">
						<span><EnvelopeIconBlue className="icon-contact-info" /></span><span>Email</span>
					</Link>
					<Link href={whatsapp_link} className="text-xxs btn btn-light-blue" target="_blank">
						<span><WhatsAppIconBlue className="icon-contact-info" /></span><span className="d-none d-md-flex">WhatsApp</span>
					</Link>
			   </div>
            )}
			
			{props?.sidebarWidget?.ShowAgents && props?.peoples?.length > 0 ? (
				<div className="agent-info">
					<div className="agent-pic">
						<img src={props.peoples[0]?.Tile_Image?.url || Dacha} alt="Agent" />
					</div>
					<div className="agent-data">
						<h6 className="text-sm-bold"><Link href={`/about-dacha/our-team/${props.peoples[0]?.URL}/`}>{props.peoples[0]?.Name}</Link></h6>
						<p className="text-xxs">{props.peoples[0]?.Designation}</p>
					</div>
				</div>
			) : (
				<div className="agent-info">
					<div className="agent-pic default-logo">
						<img src={Dacha} alt="Dacha Logo" />
					</div>
					<div className="agent-data">
						<div className="default-contact-phone">
							<Link href={`tel:${number}`} className="text-sm">
								<span><PhoneIconGrey className="icon-contact-info" /></span>
								<span>{number}</span>
							</Link>
						</div>
						<div className="default-contact">
							<Link onClick={openContactformModal} className="text-sm contact-mail">
								<span><EnvelopeIconGrey className="icon-contact-info" /></span><span>Email</span>
							</Link>
							<Link href={whatsapp_link} className="text-sm" target="_blank">
								<span><WhatsAppIconGreen className="icon-contact-info" /></span><span>WhatsApp</span>
							</Link>
						</div>
					</div>
				</div>
			)}
			{content?.Opening_Hours && (
				<div className="open-timing text-sm">
					{HTMLReactParser(content.Opening_Hours.replace(/<br\s*\/?>/gi, ''))}
				</div>
			)}
			<ModalTiny show={modalContactformOpen} onHide={closeContactformModal} className="modal-form-wrapper">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeContactformModal}><CloseIcon /></div>
                    <ModalTiny.Title>
						<h4>Contact</h4>
						<p className="text-sm">The Dacha team is always ready to help and answer any questions. Chat online with our friendly property experts or get in touch using the form below </p>
					</ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <ContactForm />
                </ModalTiny.Body>
                </ModalTiny>
		</div>
	);
};

export default StaticPageSidebar;